// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2IB8m","col":"styles_col__1EgBy"};